var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M7 .667A6.333 6.333 0 1 0 13.334 7 6.341 6.341 0 0 0 7 .667Zm0 12A5.666 5.666 0 1 1 12.667 7 5.673 5.673 0 0 1 7 12.667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M7 3.667A.333.333 0 0 0 6.667 4v3.996a.333.333 0 1 0 .667 0V4A.333.333 0 0 0 7 3.667ZM7 9a.333.333 0 0 1 .334.333V10a.333.333 0 1 1-.667 0v-.667A.333.333 0 0 1 7 9Z"
  })));
};
export default SvgWarningCircle;